import type { PlanFinding } from '@/lib/apiTypes'
import { EmptyState } from '@/shared/components/EmptyState'
import { SkeletonTable } from '@/shared/components/Skeleton'
import { Tooltip } from '@/shared/components/Tooltip'
import { SeverityBadge } from '@/shared/components/Badge'

// ── Findings tab ─────────────────────────────────────────────────────────────
export function PlanFindingsList({ findings, sensitiveCount, loading }: { findings: PlanFinding[]; sensitiveCount: number; loading: boolean }) {
  if (loading) return <SkeletonTable headers={['Severity', 'Rule', 'Resource', 'Title']} rows={4} firstColTwoLines={false} />
  return (
    <div className="fu">
      {sensitiveCount > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: 'var(--bg2)', border: '1px solid var(--border-amber)', borderRadius: 6, marginBottom: 14 }}>
          <span className="badge badge-red" style={{ fontSize: '0.6rem' }}>⚠ {sensitiveCount} sensitive change{sensitiveCount !== 1 ? 's' : ''}</span>
          <span style={{ fontSize: '0.72rem', color: 'var(--text2)' }}>This plan alters sensitive-marked attributes. Count and location only — values are never sent to the browser.</span>
        </div>
      )}
      {findings.length === 0 ? (
        <EmptyState icon="✓" title="No plan findings." subtitle="Drift, replacement-cause and secret-exposure findings are produced by the plan scanner (M3)." />
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th><Tooltip text="Severity the plan scanner assigned to the finding." placement="top"><span tabIndex={0} className="cursor-help">Severity</span></Tooltip></th><th><Tooltip text="Id of the rule that fired." placement="top"><span tabIndex={0} className="cursor-help">Rule</span></Tooltip></th><th><Tooltip text="Resource address the finding is about." placement="top"><span tabIndex={0} className="cursor-help">Resource</span></Tooltip></th><th><Tooltip text="What the finding is." placement="top"><span tabIndex={0} className="cursor-help">Title</span></Tooltip></th></tr></thead>
            <tbody>
              {findings.map((f) => (
                <tr key={f.id}>
                  <td><SeverityBadge severity={f.severity} /></td>
                  <td style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text3)' }}>{f.rule_id ?? '-'}</td>
                  <td style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text2)' }}>{f.resource ?? '-'}</td>
                  <td style={{ fontSize: '0.8rem' }}>{f.title}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
